import api from '@/api'
import { Validator } from 'vee-validate'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import Vuex from 'vuex'
import stateConfig from './config'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

export default {
  [stateConfig.LOGIN]: function (state) {
    state.loading = true
  },
  [stateConfig.LOGIN_SUCCESS]: function (state) {
    state.isLoggedIn = true
    state.loading = false
  },
  [stateConfig.LOGIN_FAIL]: function (state) {
    state.loading = false
  },
  [stateConfig.LOGOUT]: function (state) {
    state.isLoggedIn = false
    state.loading = false
  },
  [stateConfig.SELECT_BOT]: function (state) {
    state.isSelectedBot = true
  },
  [stateConfig.LOADING]: function (state) {
    state.loading = !state.loading
  },
  [stateConfig.CLEAR_LOADING]: function (state) {
    state.loading = false
  },
  [stateConfig.SIDEBAR]: function (state) {
    state.openSidebar = !state.openSidebar
  },
  [stateConfig.SELECT_NEW_BOT]: function (state, bot) {
    state.selectedBot = bot
  },
  [stateConfig.UPDATE_SETTING]: function (state, setting) {
    state.setting = setting
  },
  [stateConfig.UPDATE_WELCOME_MESSAGE]: function (state, welcomeMessage) {
    state.welcomeMessage = welcomeMessage
  },
  [stateConfig.UPDATE_MODAL_WELCOME]: function (state, value) {
    if (value) {
      state.showModalWelcome = true
      Vue.localStorage.set('showModalWelcome', true)
    } else {
      state.showModalWelcome = undefined
      Vue.localStorage.remove('showModalWelcome')
    }
  },
  [stateConfig.SET_LANG](state, payload) {
    const lang = Vue.localStorage.get('lang')
    Vue.localStorage.set('lang', payload)
    Vue.i18n.set(payload)
    Validator.localize(payload)
    if (state.userid) {
      var data = {
        lang: payload,
        tutoriallist: state.tutoriallist
      }
      api.updateTutoriallist(data, function (error, response) {
        if (error) {
          console.error(error)
        }
      })
    }
  },
  [stateConfig.UPDATE_ALERT](state, payload) {
    if (state.alert) {
      var alertIndex = state.alert.findIndex(function (alert) {
        return alert.name === payload.name
      })
      if (alertIndex > 0) {
        state.alert[alertIndex] = payload
      } else {
        state.alert.push(payload)
      }
    } else {
      state.alert.push(payload)
    }
    Vue.localStorage.set('alerts', JSON.stringify(state.alert))
  },
  [stateConfig.SET_LIVECHAT_USERS](state, payload) {
    state.livechat.userlist[payload.type].users = payload.users
  },
  [stateConfig.SET_KETSHOP_TOKEN](state, payload) {
    if (payload.useketshop !== 'undefined') state.selectedBot.useketshop = payload.useketshop
    if (payload.ketshop_api_key) state.selectedBot.ketshop_api_key = payload.ketshop_api_key
    if (payload.ketshop_api_secret)
      state.selectedBot.ketshop_api_secret = payload.ketshop_api_secret

    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
  },
  // $store.commit('modalAssign', {open: true, component: () => import('@/Mootest.vue') })
  modalAssign(state, data) {
    let input = JSON.parse(JSON.stringify(data.input))
    Object.assign(state.modal, { ...data, input })
  },
  allSchoolsAssign(state, data) {
    Object.assign(state.allSchools, data)
  },
  [stateConfig.SET_LIVECHAT_USER](state, payload) {
    state.livechat.currentUser = payload
  },
  ['SELECT_PAGE_LIVECHAT'](state, payload) {
    state.livechat = {
      ...state.livechat,
      bot: payload,
      pageid: payload.value,
      theme: payload.theme,
      userlist: {
        admin: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        },
        bot: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        }
      }
    }
    // Search users in line only
    // For KFC only and TOA E-Coupon
    if (['102052945584054', '106855151601601', '100707492390105'].includes(payload.value)) {
      state.livechat.app = 'line'
    }
  },
  ['UPDATE_ASTON_ADMIN'](state, payload) {
    state.astonAdmins = payload
  },
  ['SET_LIVECHAT_FILTER'](state, payload) {
    state.livechat.filter = payload
  },
  ['SET_LIVECHAT_TYPE'](state, payload) {
    state.livechat.inbox = payload
  },
  ['SET_LIVECHAT_APP'](state, payload) {
    state.livechat.app = payload
  },
  ['SET_LIVECHAT_PLATFORM_TYPE'](state, payload) {
    state.livechat.platform_type = payload
  },
  ['SET_LIVECHAT_USER'](state, payload) {
    state.livechat.currentUser = payload
  },
  ['SET_BOTLIST'](state, payload) {
    state.botlist = payload
  },
  ['SET_DELAY_IMPORT'](state, payload) {
    if (state.delayImportUserTime.length == 0) {
      state.delayImportUserTime.push(payload)
    } else {
      var index = state.delayImportUserTime.findIndex((el) => {
        return el.pageid == payload.pageid
      })
      if (index != -1) {
        Vue.set(state.delayImportUserTime, index, payload)
      } else {
        state.delayImportUserTime.push(payload)
      }
    }
    Vue.localStorage.set('delayImportUserTime', JSON.stringify(state.delayImportUserTime))
  },
  ['REMOVE_DELAY_IMPORT'](state, payload) {
    if (state.delayImportUserTime.length == 0) {
    } else {
      var index = state.delayImportUserTime.findIndex((el) => {
        return el.pageid == payload.pageid
      })
      if (index != -1) {
        state.delayImportUserTime.splice(index, 1)
      }
    }
    Vue.localStorage.set('delayImportUserTime', JSON.stringify(state.delayImportUserTime))
  },
  ['SET_INTENTS'](state, { intents, loadingIntents }) {
    if (intents !== undefined) {
      state.intents = intents.map(function (val) {
        var intent = { ...val }
        intent.isShow = false

        intent.ableToDelete = ![
          '{welcome}',
          '{default}',
          '{default_comment_to_inbox}',
          '{default_live}'
        ].includes(intent.intentname)
        return intent
      })
    } else {
      state.intents = []
    }
    state.loadingIntents = loadingIntents
  },
  ['SET_INTENT'](state, payload) {
    if (payload.id) {
      var index = state.intents.findIndex((el) => {
        return el.id == payload.id
      })
      if (index != -1) {
        Vue.set(state.intents, index, payload)
      } else {
        state.intents.push(payload)
      }
    } else {
      state.intents.push(payload)
    }
  },
  ['DELETE_INTENT'](state, id) {
    var index = state.intents.findIndex((el) => {
      return el.id == id
    })
    if (index != -1) {
      state.intents.splice(index, 1)
    }
  },
  ['SET_CURRENT_USER_TICKET'](state, tickets) {
    state.currentUserTicket = tickets
  },
  ['SET_TICKET_LOADING'](state, value) {
    state.currentUserTicketLoading = value
  },
  ['UPDATE_CURRENT_USER_TICKET'](state, ticket) {
    var index = state.currentUserTicket.findIndex((v) => v.id == ticket.id)
    state.currentUserTicket.splice(index, 1, ticket)
  },

  ['ADD_EDITTING_INTENT'](state, payload) {
    let intent = state.edittingIntent.find((el) => {
      return el == payload
    })

    if (!intent) state.edittingIntent.push(payload)
  },
  ['REMOVE_EDITTING_INTENT'](state, payload) {
    let index = state.edittingIntent.findIndex((el) => {
      return el == payload
    })

    if (index != -1) state.edittingIntent.splice(index, 1)
  },
  ['CLEAR_EDITTING_INTENT'](state) {
    state.edittingIntent = []
  },
  ['SET_TOA_CAMPAIGN'](state, payload) {
    state.selectToaCampaign = payload
  },
  ['SET_TOA_ENABLE_CAMPAGIN'](state, payload) {
    state.toaEnableCampaignList = payload
  },
  ['SET_GENERALI_GAME_SETTING'](state, payload) {
    state.generaliGameSetting = payload
  },
  ['SET_TICKET_TAGS'](state, payload) {
    state.ticketTags = payload
  },
  ['SET_TICKET_TAGS_PAGE_ID'](state, payload) {
    state.ticketTagsPageId = payload
  },
  ['SET_TICKET_TAGS_FULL'](state, payload) {
    state.ticketTagsFull = payload
  },
  ['SET_IS_USER_ONLINE'](state, payload) {
    state.isUserOnline = payload
  },
  ['SET_PING_LOGIN_TIMER'](state, payload) {
    state.pingLoginTimer = payload
  },
  ['SET_TTB_CHILD_PAGES'](state, payload) {
    state.ttbChildPages = payload
  },
  ['SET_COUNT_AGENT_ONLINE_OFFLINE_TIMER'](state, payload) {
    state.ttbCountAgentStatusTimer = payload
  },
  ['SET_COUNT_AGENT_ONLINE_OFFLINE'](state, payload) {
    state.ttbCountAgentStatus = payload
  },
  ['SET_LIVECHAT_NOTIUNREAD'](state, payload) {
    Vue.set(state.livechat.notiunread, payload.pageid, payload.data)
    // state.livechat.notiunread[payload.pageid] = payload.data
  },
  ['SET_CHECK_IN'](state, payload) {
    console.log(payload)
    state.checkIn = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js